"use client";

import React, { Suspense } from "react";
import TopBar from "./components/TopBar";
import Breadcrumb from "./components/TopBar/Breadcrumb";
import { usePathname } from "next/navigation";
import dynamic from "next/dynamic";
import { cn } from "@litonarefin/utils";

const ListView = dynamic(() => import("./ListView"));
const GridView = dynamic(() => import("./GridView"));

const Wrapper = ({ children, data, category, className = "" }) => {
  let pathname = usePathname();

  if (pathname.startsWith("/")) {
    pathname = pathname.substring(1);
  }

  const pathArr = pathname.split("/");

  const rootCategory = pathArr[1] === category;

  return (
    <section
      className={cn(
        "jlt-docs-wrapper jlt-pt-[96px] md:jlt-pt-[128px] lg:jlt-pt-[164px] jlt-pb-[128px]",
        className
      )}
    >
      <div className="jt-container jlt-mx-auto">
        <TopBar data={data} />
        <Breadcrumb data={data} />

        <Suspense>
          {rootCategory && pathArr.length === 2 ? (
            <GridView data={data} />
          ) : (
            <ListView data={data}>{children}</ListView>
          )}
        </Suspense>
      </div>
    </section>
  );
};

export default Wrapper;
